import React from 'react';
import ReactTable from "react-table";
import { Row, Col, Button } from 'react-bootstrap';

import "react-table/react-table.css";

import constants from '../.././util/constants';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import { uniq } from 'underscore';
import FontAwesome from 'react-fontawesome';
import { export2Excel, filterNumber, filterMultiple, getFilteredData, setDataForExpansion, getSum, getExpander } from '../../gridHelpers/gridHelpers';

import LoadingSpinner from '../../LoadingSpinner';
import NPHelpButton from '../../NPHelpButton';
import ReactGA from 'react-ga';
import './style.scss';
import NPReactTable from '../../NPReactTable';
import * as Grants from '../.././util/grants';
import { hasGrant } from '../.././util/grantHelper';
import * as Convert from '../../util/unitConversion';

const { API_BASE_URL } = constants;

class StockSearchDataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getClearedState();
        this.resetState = this.resetState.bind(this);
        // this.handleGradeSelectChange = this.handleGradeSelectChange.bind(this);
        // this.handleClientSelectChange = this.handleClientSelectChange.bind(this);
        this.tell = this.tell.bind(this);
        this.help = this.help.bind(this);
        this.excelExport = this.excelExport.bind(this);
        this.getSums = this.getSums.bind(this);
        this.getcolumns = this.getcolumns.bind(this);
        this.clearCurrentExpandforAll = this.clearCurrentExpandforAll.bind(this);
        this.getData = this.getData.bind(this);
    }

    getcolumns() {

        const helpNode = (
            <div>
                <h3>Buttons</h3>

                <h4>Reset</h4>
                <p>Resets filters, sorting, column widths and navigates to first page.</p>

                <h4>Excel</h4>
                <p>Exports the data to excel according to filters and sorting.</p>

                <h3>Filters</h3>

                <p>There are fields at the top of the table that can be used for filtering</p>

                <p>
                    If a text box for a column is empty, no filtering for that column will be done.<br />
                    If the data is left-aligned and the text box is not empty, the filter will remove rows that do not contain the text in the text box<br />
                    It is possible to use multiple filters for text based values by writing a comma, for example "Ordered, Being produced"<br /><br />
                    Examples follows for right-aligned (numbers):<br />
                    Empty text box, no filtering.<br />
                    <strong>&lt; 10</strong> view rows with data that is less than 10<br />
                    <strong>&gt; 10</strong> view rows with data that is more than 10<br />
                    <strong>20-30</strong> view rows with data that is between 20 and 30.
                </p>
            </div>
        )

        return ([
            {

                Header: "Order information",
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {
                        Header: "",
                        maxWidth: 30,
                        Filter: ({ filter, onChange }) =>
                            <NPHelpButton content={helpNode} title="Help" />,
                        sortable: false,
                        show: hasGrant(Grants.TYPES.Stock_CreateCalloff),
                        Cell: (row) => {
                            if (row.original.CALL_OFF == 1 && row.original.AVAILABLE_QUANTITY > 0 && row.original.AVAILABLE_WEIGHT_UC > 0)
                                return (
                                    <span>
                                        <select className='tst myopt handy' onChange={evt => { this.handleSelectChange(evt, evt.target.value, row, this) }}>
                                            <option value="">...</option>
                                            <option value="create">Create new Call off with this order (selected item) as template</option>
                                            <option value="copy">Call off row to existing Call off</option>
                                        </select>
                                    </span>
                                )
                        }
                    },
                    {
                        show: hasGrant(Grants.TYPES.General_ExpandOrderDetails),
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'ORDER_COMBO', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },
                    {
                        Header: "Order nr.",
                        accessor: "ORDER_COMBO",
                        maxWidth: 80,
                    },
                    {
                        Header: "Loading nr.",
                        accessor: "LOADING_NO_ALT",
                        maxWidth: 160,
                    },
                    {
                        expander: true,
                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'CLIENT_CODE_REGIONAL', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },
                    {
                        Header: "Client",
                        accessor: "CLIENT_CODE_REGIONAL",
                        maxWidth: 100,
                        filterMethod: (filter, row) => row[filter.id].toUpperCase().includes(filter.value.toUpperCase())
                    },
                    {
                        Header: "Name",
                        accessor: "SHORT_NAME",
                        maxWidth: 100,
                        filterMethod: this.clientFilter
                        // filterMethod:(filter, row) =>  row[filter.id].toUpperCase().includes(filter.value.toUpperCase())
                    },
                    {
                        Header: "Call off",
                        accessor: "CALL_OFF",
                        maxWidth: 50,
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "Customer po",
                        accessor: "CUSTOMER_PO",
                        maxWidth: 120,
                    },
                    {
                        Header: "FSC",
                        accessor: "FSC",
                        maxWidth: 50,
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "PEFC",
                        accessor: "PEFC",
                        maxWidth: 50,
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "CW",
                        accessor: "CW_MARK",
                        maxWidth: 50,
                        style: { "textAlign": "right" },
                        filterMethod: filterNumber,
                    },
                    {
                        Header: "Sales price",
                        accessor: "UNIT_PRICE_COMMITTED",
                        maxWidth: 75,
                        style: { "textAlign": "right"},
                        filterMethod: filterNumber
                    },
                    {
                        Header: "Currency",
                        accessor: "CURRENCY_CODE",
                        maxWidth: 75,
                    },
                    {
                        Header: "Customer PO",
                        accessor: "CUSTOMER_PO",
                        show: false
                    }
                ]
            },
            {
                Header: "Product",
                headerStyle: { background: '#EEEEEE' },
                columns: [
                    {
                        expander: true,

                        width: 35,
                        Expander: ({ isExpanded, ...row }) =>
                            getExpander(row, 'PRODUCT_CODE', this, isExpanded),
                        style: {
                            cursor: "pointer",
                            textAlign: "center",
                            userSelect: "none"
                        },
                    },
                    {
                        Header: "Code",
                        accessor: "PRODUCT_CODE",
                        maxWidth: 130,
                        minWidth: 130,
                    },
                    {
                      Header: "Product Name",
                      accessor: "GRADE_DESCRIPTION",
                      maxWidth: 170,
                    },
                    {
                        Header: "Description",
                        accessor: "PRODUCT_DESC_ALT",
                        maxWidth: 80,
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Width (mm)"} value_imperial={"Width (in)"}/>),
                        accessor: "WIDTH_UC",
                        maxWidth: 100,
                        filterMethod: filterNumber,
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Format (mm)"} value_imperial={"Format (in)"}/>),
                        accessor: "FORMAT_UC",
                        minWidth: 100,
                        filterMethod: filterNumber,
                        style: { "textAlign": "right" }
                    },

                    {
                        Header: (<Convert.TextTo value_metric={"Grammage"} value_imperial={"Basis Weight"}/>),
                        accessor: "BASIS_WEIGHT_UC",
                        minWidth: 90,
                        filterMethod: filterNumber,
                        style: { "textAlign": "right" },
                        id:'BASIS_WEIGHT_UC',
                        Cell: row => (
                            <div><Convert.AddSymbol check={row.original.BASIS_WEIGHT_UC}/>{row.original.BASIS_WEIGHT_UC}</div>
                        )
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Core (mm)"} value_imperial={"Core (in)"}/>),
                        accessor: "ROLL_CORE_FORMAT_UC",
                        maxWidth: 80
                    }
                ]
            },
            {
                Header: "Info",
                headerStyle: { background: '#DDDDDD' },
                columns: [
                    {
                        Header: "Exmill week",
                        accessor: "DELIVERYTIME_WEEK",
                        maxWidth: 80,
                    },
                    {
                        Header: "Days in stock",
                        accessor: "DAYS_IN_STOCK",
                        maxWidth: 100,
                        filterMethod: filterNumber,
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: "Warehouse",
                        accessor: "PALLET_LOCATION_AREA",
                        maxWidth: 120
                    },
                    {
                        Header: "Quantity",
                        accessor: "QUANTITY",
                        maxWidth: 100,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.quantityTotal}</strong>
                            </span>
                        ),
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: "Available Quantity",
                        accessor: "AVAILABLE_QUANTITY",
                        minWidth: 120,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.availableQuantityTotal}</strong>
                            </span>
                        ),
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Weight (kg)"} value_imperial={"Weight (lb)"}/>),
                        accessor: "WEIGHT_UC",
                        maxWidth: 100,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.weightTotal}</strong>{" "}
                            </span>
                        ),
                        style: { "textAlign": "right" }
                    },
                    {
                        Header: (<Convert.TextTo value_metric={"Available Weight (kg)"} value_imperial={"Available Weight (lb)"}/>),
                        accessor: "AVAILABLE_WEIGHT_UC",
                        minWidth: 130,
                        filterMethod: filterNumber,
                        Footer: (
                            <span>
                                <strong>{this.state.availableWeightTotal}</strong>{" "}
                            </span>
                        ),
                        style: { "textAlign": "right" }
                    },
                ]
            }
        ]);
    }

    excelExport() {
        const isImperial = window.sessionStorage.getItem('UnitConversion') === "IMPERIAL";
        export2Excel(this.props.apiToken, this.reactTable.getReactTable(), "Stock.xlsx", isImperial);
        this.GAtrackHandler();
    }

    GAtrackHandler(e) {
        ReactGA.event({
            category: "User action",
            action: "Stock was exported as Excel",
        });
    }

    resetState() {
        this.setState(this.getClearedState());
    }

    handleSelectChange(evt, action, row, self) {
        row = row.original || row;
        if (row) {
            if (action === 'create') {
                this.props.callOffFunctions.create(row);
            }
            else if (action === 'copy') {
                this.props.callOffFunctions.copy(row, this.props.search);
            }
        }
        evt.currentTarget.selectedIndex = 0;    
    }

    getClearedState() {
        let data = this.props.data;
        return ({
            sorted: [],
            page: 0,
            pageSize: 10,
            expanded: {},
            resized: [],
            filtered: [],
            showModal: false,
            selectedProductCode: '',
            gradeFilter: null,
            clientFilter: null,
            ...this.getSums(data)
        });
    }

    tell(txt, row) {
        setDataForExpansion(txt, row, this.props.apiToken, this);
    }

    getOptionLabelAndValue(values) {
        //values.splice(0,0,'');
        values.sort();
        values = uniq(values);
        return values.map(v => ({ value: v, label: v }));
    }

    help() {
        alert('Buttons:\nReset: Resets filters, sorting, column widths and sets page to page 1.\n' +
            'Excel: Exports the data to excel according to filters and sorting.\n\n' +
            'To select an unknown client, please select it from the "Client" dropdown control.\n' +
            'To select an unknown grade, please select it from the Grade" dropdown control.\n\n' +
            'Filters:\nBelow the columns filter we have input text boxes that can be used for filtering\n' +
            'If a text-box for a column is empty, no filtering for that column will be done.\n' +
            'If the data is left-aligned and the text-box is not empty, the filter will remove rows that do not contain the the text in the text-box.\n' +
            'Examples follows for right-aligned (numbers):\n' +
            'Empty text-box, no filtering.\n>10 filters rows with column data with 10 or less\n' +
            '<10 filters rows with column data 10 or more\n20-30 filters rows with data that is not between 20 and 30.');
    }

    getSums(data) {
        let result = {
            quantityTotal: getSum(data, "QUANTITY"),
            availableQuantityTotal: getSum(data, "AVAILABLE_QUANTITY"),
            weightTotal: getSum(data, "WEIGHT_UC"),
            availableWeightTotal: getSum(data, "AVAILABLE_WEIGHT_UC"),
        };
        return result;
    }

    updateSums() {
        let states = this.getSums(getFilteredData(this.reactTable.getReactTable()));
        this.setState(states);
    }

    clearCurrentExpandforAll() {
        let d = getFilteredData(this.reactTable.getReactTable());
        d.forEach(dt => {
            dt.TAG = undefined;
        });
        this.currentExpand = '';
    }

    getData() {
        let self = this;

        this.setState({ isLoading: true });

        const header = {
            'Authorization': 'Bearer ' + this.props.apiToken,
            'Accept': 'application/octet-stream'
        };

        axios.get(API_BASE_URL + 'StockSearch/GetStockData', { headers: header })
            .then(result => {
                self.setState({ data: result.data, isLoading: false });
            })
            .catch(response => {
                self.setState({ isLoading: false });
            });
    }

    render() {

        const { data, apiToken } = this.props;
        if (this.state.isLoading) {
            return <LoadingSpinner isLoading={true} />
        }
        return (
            <Row>
                <Col xs={12}>
                    <Button bsStyle="primary" className="btn-sm" onClick={this.resetState}>Reset</Button>
                    {hasGrant(Grants.TYPES.General_ExportToExcel) && <Button bsStyle="primary" className="btn-sm margin-left-10" onClick={this.excelExport}>Excel</Button>}
                    <Button bsStyle="primary" className="btn-sm pull-right" onClick={this.getData}>Refresh</Button>
                </Col>
                <Col xs={12}>
                    <NPReactTable
                        data={data}
                        className="margin-top-10 np-react-table"
                        ref={(r) => { this.reactTable = r }}
                        defaultFilterMethod={filterMultiple}
                        columns={this.getcolumns()}
                        filterable
                        filterAll
                        defaultPageSize={10}
                        // Controlled props
                        sorted={this.state.sorted}
                        page={this.state.page}
                        pageSize={this.state.pageSize}
                        expanded={this.state.expanded}
                        resized={this.state.resized}
                        filtered={this.state.filtered}
                        // Callbacks
                        onSortedChange={sorted => this.setState({ sorted })}
                        onPageChange={
                            page => {
                                this.clearCurrentExpandforAll();
                                this.setState({ page, expanded: {} });
                            }
                        }
                        onPageSizeChange={(pageSize, page) => {
                            this.clearCurrentExpandforAll();
                            this.setState({ page, pageSize, expanded: {} });
                        }
                        }
                        onResizedChange={resized => this.setState({ resized })}
                        onFilteredChange={filtered => {
                            this.updateSums();
                            this.clearCurrentExpandforAll();
                            this.setState({ filtered, page: 0, expanded: {} })
                        }
                        }

                        SubComponent={row => {
                            let r = row.original;
                            let t = 'EXP_' + r.TAG;
                            if (r.TAG && r.TAG !== '' && r[t]) {
                                return r[t];
                            }
                        }
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default StockSearchDataTable;
